// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .header-panel {
  background-color: var(--headerBackground);
  color: var(--headerColor);
  position: absolute;
  top: 0px;
  left: 0px;
  height: 36px;
  width: 100%;
  text-align: center;
  line-height: 36px;
  border-bottom: 1px solid var(--headerBorder);
}
:host .header-panel mat-icon {
  display: inline-block;
  vertical-align: text-top;
}
:host .work-panel {
  position: absolute;
  top: 37px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: var(--workPanelBackground);
}
:host .mat-column-select {
  overflow: visible;
  flex: 0 0 80px;
}
:host .mat-column-name {
  flex: 1 1 200px;
}
:host .mat-column-view {
  flex: 1 1 140px;
}
:host .mat-column-description {
  flex: 1 1 140px;
}
:host .mat-column-remove {
  flex: 0 0 60px;
}
:host .mat-cell {
  font-size: 13px;
}
:host .mat-header-row {
  top: 0;
  position: sticky;
  z-index: 1;
}
:host .mat-header-cell {
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/maps/maps-location-list/maps-location-list.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/maps/maps-location-list/maps-location-list.component.scss"],"names":[],"mappings":"AACI;EACI,yCAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,4CAAA;ACAR;ADEQ;EACI,qBAAA;EACA,wBAAA;ACAZ;ADII;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,4CAAA;ACFR;ADKI;EACI,iBAAA;EACA,cAAA;ACHR;ADMI;EACI,eAAA;ACJR;ADOI;EACI,eAAA;ACLR;ADQI;EACI,eAAA;ACNR;ADQI;EACI,cAAA;ACNR;ADSI;EACI,eAAA;ACPR;ADUI;EACI,MAAA;EACA,gBAAA;EACA,UAAA;ACRR;ADWI;EACI,eAAA;ACTR","sourcesContent":[":host {\n    .header-panel {\n        background-color: var(--headerBackground);\n        color: var(--headerColor);\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        height: 36px;\n        width: 100%;\n        text-align: center;\n        line-height: 36px;\n        border-bottom: 1px solid var(--headerBorder);\n\n        mat-icon {\n            display: inline-block;\n            vertical-align: text-top;\n        }\n    }\n\n    .work-panel {\n        position: absolute;\n        top: 37px;\n        left: 0px;\n        right: 0px;\n        bottom: 0px;\n        background-color: var(--workPanelBackground);\n    }\n\n    .mat-column-select {\n        overflow: visible;\n        flex: 0 0 80px;\n    }\n\n    .mat-column-name {\n        flex: 1 1 200px;\n    }\n\n    .mat-column-view {\n        flex: 1 1 140px;\n    }\n\n    .mat-column-description {\n        flex: 1 1 140px;\n    }\n    .mat-column-remove {\n        flex: 0 0 60px;\n    }\n\n    .mat-cell {\n        font-size: 13px;\n    }\n\n    .mat-header-row {\n        top: 0;\n        position: sticky;\n        z-index: 1;\n    }\n\n    .mat-header-cell {\n        font-size: 15px;\n    }\n}",":host .header-panel {\n  background-color: var(--headerBackground);\n  color: var(--headerColor);\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 36px;\n  width: 100%;\n  text-align: center;\n  line-height: 36px;\n  border-bottom: 1px solid var(--headerBorder);\n}\n:host .header-panel mat-icon {\n  display: inline-block;\n  vertical-align: text-top;\n}\n:host .work-panel {\n  position: absolute;\n  top: 37px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  background-color: var(--workPanelBackground);\n}\n:host .mat-column-select {\n  overflow: visible;\n  flex: 0 0 80px;\n}\n:host .mat-column-name {\n  flex: 1 1 200px;\n}\n:host .mat-column-view {\n  flex: 1 1 140px;\n}\n:host .mat-column-description {\n  flex: 1 1 140px;\n}\n:host .mat-column-remove {\n  flex: 0 0 60px;\n}\n:host .mat-cell {\n  font-size: 13px;\n}\n:host .mat-header-row {\n  top: 0;\n  position: sticky;\n  z-index: 1;\n}\n:host .mat-header-cell {\n  font-size: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
